//WPML plugin causing error for my-account navigation links, this js helps to resolve it.

const COOKIE_KEY = 'uh_leight_nav_collapsed';
const MOBILE_NAV_QUERY = '(max-width: 1023px)';

function getCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
}

function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
}

export default class MyAccount {

    constructor() {
        this.navigations = document.querySelectorAll("a[data-hrefAttr]");
        this.nav = document.querySelector('.woocommerce-MyAccount-navigation');
    }

    init() {
        if (this.navigations) {
            this.changeNavigationsLinks();
        }
        if (this.nav) {
            this.initCollapse();
        }
        this.initProgressBars();
        this.initLeightHeaderHeight();
    }

    changeNavigationsLinks() {
        this.navigations.forEach((navigation) => {
            let href = navigation.getAttribute('data-hrefAttr');
            if (href) {
                navigation.setAttribute('href', href);
                navigation.removeAttribute('data-hrefAttr');
            }
        });
    }

    // Plugin JS only animates bars inside .profile-progress-bar-wrapper;
    // achievement bars use data-percentage but never get --width set.
    initProgressBars() {
        document.querySelectorAll('.uh-minimize-progressbar .levcharity_progressbar').forEach((bar) => {
            const pct = bar.dataset.percentage ?? bar.style.width;
            const w   = pct ? (String(pct).includes('%') ? pct : `${pct}%`) : null;
            if (w) {
                bar.style.setProperty('--width', w);
                bar.style.setProperty('--opacity', '1');
            }
        });
    }

    initLeightHeaderHeight() {
        if (!document.body.classList.contains('uh-leight-my-account')) {
            return;
        }

        const header = document.querySelector(
            '.wp-site-blocks > header.wp-block-template-part .leight-campaign-header'
        );

        if (!header) {
            return;
        }

        const update = () => {
            const headerWrapper = header.closest('header') || header;
            const height = Math.ceil(headerWrapper.getBoundingClientRect().height);

            document.documentElement.style.setProperty('--cat-header-height', `${height}px`);
        };

        update();
        window.addEventListener('resize', update);
    }

    initCollapse() {
        const mobileNav = window.matchMedia(MOBILE_NAV_QUERY);
        const updateCollapseState = () => {
            const shouldCollapse = mobileNav.matches || getCookie(COOKIE_KEY) === 'collapsed';
            this.nav.classList.toggle('is-collapsed', shouldCollapse);
        };

        updateCollapseState();
        mobileNav.addEventListener('change', updateCollapseState);

        this.nav.addEventListener('click', (e) => {
            const collapseBtn = e.target.closest('.woocommerce-MyAccount-navigation-link--collapse a');
            const expandBtn   = e.target.closest('.woocommerce-MyAccount-navigation-link--expand a');

            if (collapseBtn) {
                e.preventDefault();
                this.nav.classList.add('is-collapsed');
                setCookie(COOKIE_KEY, 'collapsed', 365);
            } else if (expandBtn) {
                e.preventDefault();

                if (mobileNav.matches) {
                    this.nav.classList.add('is-collapsed');
                    return;
                }

                this.nav.classList.remove('is-collapsed');
                setCookie(COOKIE_KEY, '', -1);
            }
        });
    }
}
